export default "__VITE_ASSET__BgFeShDX__"